import React, { createContext, useEffect } from 'react';
import { Box } from '@mui/material';
import Header from '../src/layouts/Applayouts/HeaderLayout/Header';
import Footer from '../src/layouts/Applayouts/FooterLayout/Footer';
import AppRoutes from './routes/AppRoutes';
import { useAppSelector } from './hooks/useAppSelector';
import LoginHeader from './layouts/Applayouts/HeaderLayout/LoginHeader';
import AircallWorkspace from 'aircall-everywhere';
import { HashRouter as Router, useLocation } from 'react-router-dom';
import { ToastContainer } from 'react-toastify';
import { FacilityProvider } from '../src/context/FacilityContext';
import 'react-toastify/dist/ReactToastify.css';
import LogRocket from 'logrocket';

// Define the type of the context
type PhoneContextType = AircallWorkspace | null;
// Create the context with the correct type
export const PhoneContext = createContext<PhoneContextType>(null);
//header set based on the route path name
const HeaderSelector: React.FC = () => {
  const location = useLocation();
  const [sessionLogin, setSessionLogin] = React.useState<boolean>(false);
  const shouldUseSpecialHeader = ['/WaitingPage', '/TestOperator', '/'].includes(location.pathname);
  React.useEffect(() => {
    setSessionLogin(sessionStorage.getItem('isLogin') === 'true');
  }, [sessionStorage.getItem('isLogin')]);// eslint-disable-line react-hooks/exhaustive-deps
  return (
    <>
      {
        sessionLogin
          ? <Header isvisible={shouldUseSpecialHeader ? false : true} />
          : <LoginHeader />
      }
    </>
  );
}
const App: React.FC = () => {
  const phone = useAppSelector((state) => state.phone.phone);

  useEffect(() => {
    const logRocketAppId = window.config.logRocketAppId;
    LogRocket.init(logRocketAppId, {
      dom: {
        privateAttributeBlocklist: ["data-mask-sensitive"]
      }
    });
  }, []);
  return (
    <Router>
      <PhoneContext.Provider value={phone}>
      <FacilityProvider>
        <HeaderSelector />
        <Box py={5} component={'main'} minHeight={'calc(100vh - 125px)'}>
          {/* <Container maxWidth={'lg'}> */}
          <Box mx={4} maxWidth='calc(100vw - 468px)'>
            {/* Dynamic router components */}
            <AppRoutes />
          </Box>
          {/* </Container> */}
        </Box>
        <Footer />
        <ToastContainer />
        </FacilityProvider>
      </PhoneContext.Provider>
    </Router>
  );
};
export default App;
